import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { MyClaimDocumentContainerModel} from '../../../../../../models';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MyClaimSubmitDocumentService extends BaseApiTemplateService<MyClaimDocumentContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'documents/processors/submission/login-entity-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'documents/processors/submission/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'documents/processors/submission/login-entity-ep';
    this.httpClient = http;
  }

  public printJasperPdf(
    guid: string,
    printableFormatGuid: string,
    visa: ApiVisa,
  ): Observable<Blob> {
    let params = new HttpParams().set("printableFormatHdrGuid", printableFormatGuid);
    let url;

    const body = {
      claim_doc_hdr_guids: [guid]
    }

    url =
      visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'documents/claim-summary-pdf/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    return this.httpClient.post<Blob>(
      url, body,
      this.getHttpHeaderBlob(visa, params)
    );
  }
}


